import type { BranchOpenNow } from "@workspace/api-client-react";
import { cn } from "@/lib/utils";
import { formatOpenNow } from "./formatOpenNow";

export function OpenNowBadge({ openNow, className }: { openNow: BranchOpenNow | null | undefined; className?: string }) {
  const text = formatOpenNow(openNow);
  if (!text || !openNow) return null;
  const open = openNow.status === "open";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium",
        open ? "border-emerald-200 bg-emerald-50 text-emerald-800" : "border-border bg-muted text-muted-foreground",
        className,
      )}
    >
      <span aria-hidden="true" className={cn("h-1.5 w-1.5 rounded-full", open ? "bg-emerald-600" : "bg-muted-foreground")} />
      {text}
    </span>
  );
}
